import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequestProductSales } from "shared/utils/fetch-api";

export const fetchCountries = createAsyncThunk(
    'contract/fetchCountries',
    async ({
        AgentSalesDataID,
    }: {
        AgentSalesDataID: string;
    }, { rejectWithValue }) => {
        const requestBody = {
            "AgentSalesDataID": AgentSalesDataID,
            "Source": "Site",
        }
        try {
            const response = await getRequestProductSales(requestBody, 'product-sales', 'getCountries', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return {
                    Countries: data.Countries
                };
            } else {
                return rejectWithValue(data.Errors);;
            }
        } catch (error: any) {
            return error.message;
        }
    }
);

export const fetchPolicyTemplate = createAsyncThunk(
    'contract/fetchPolicyTemplate',
    async ({
        AgentSalesDataID,
    }: {
        AgentSalesDataID: string;
    }, { rejectWithValue }) => {
        const requestBody = {
            "AgentSalesDataID": AgentSalesDataID,
            "Source": "Site"
        }
        try {
            const response = await getRequestProductSales(requestBody, 'product-sales', 'getPolicyTemplate', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return {
                    PolicyTemplateDataBase64: data.PolicyTemplateDataBase64
                };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return error.message;
        }
    }
);

export const fetchCalculation = createAsyncThunk(
    'contract/fetchCalculation',
    async ({
        ProgramID,
        AgentSalesDataID
    }: {
        ProgramID: string;
        AgentSalesDataID: string;
    }, { rejectWithValue }) => {
        const requestBody = {
            "AgentSalesDataID": AgentSalesDataID,
            "Source": "Site",
            "ProgramID": ProgramID
        }
        try {
            const response = await getRequestProductSales(requestBody, 'product-sales', 'getCalculation', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return {
                    Programs: data.Programs,
                    RequestID: data.RequestID
                };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return error.message;
        }
    }
);
